import { dashCase } from '../../case/camelCase/to/dashCase';

/**
 * Devuelve una cadena valida de propiedades css
 *
 * @param {object} rules - el objeto {key: value} que corresponde a la lista de propiedades css
 * @return {string}
 *
 * @example
 * objectToCss({
 *   display: 'none',
 *   backgroundColor: 'blue',
 *   'background-color': 'blue',
 *   transition: 'transform .2s, opacity .4s',
 * }) => 'display:none;background-color:blue;background-color:blue;transition:transform .2s, opacity .4s'
 *
 */

export function css(rules) {
  if (typeof rules !== 'object' || rules === null) {
    return '';
  }
  const css = Object.entries(rules)
    .map(([key, value]) => `${dashCase(key)}:${value}`)
    .join(';');
  return css;
}
